import { Col, Card } from 'react-bootstrap';

// items = [{ label, value, color, textColor? }]
// color: 'primary' | 'success' | 'secondary' | 'danger' | 'warning'
export function KpiCards({ items, colSize = 3 }) {
  return (
    <>
      {items.map(({ label, value, color, textColor }) => (
        <Col md={6} lg={colSize} className="mb-3" key={label}>
          <Card className={`h-100 shadow-sm border-start border-4 border-${color}`}>
            <Card.Body>
              <div className="text-muted small">{label}</div>
              <h3 className={`mb-0${textColor ? ` text-${textColor}` : ''}`}>{value}</h3>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </>
  );
}
